import { Link, useNavigate } from "react-router-dom";
import serviceImg from "@/assets/service.png";
import { format } from "date-fns";
import parse from "html-react-parser";
import { Button } from "@/components/ui/button";

const MyService = ({ service }) => {
  const navigate = useNavigate();

  return (
    <div className="glass-header !border-white !border-2 p-4 rounded-lg w-full flex items-center justify-between">
      <div className="flex gap-2">
        <div className="p-4 border-muted-foreground bg-[#d7e4f7] rounded-md shadow-md">
          <img
            src={`${import.meta.env.VITE_IMG_URL}/${service?.serviceId?.icon}`}
            className="size-full aspect-square object-contain"
          />
        </div>
        <div>
          <span className="mt-1 text-gray-500 text-sm">
            {format(new Date(service?.createdAt), "dd MMM yyyy")}{" "}
          </span>
          <h2 className="text-2xl max-[560px]:text-base font-medium text-gray-900 title-font mb-2">
            {service?.serviceId?.name}
          </h2>
          <p className="text-muted-foreground">
            {service?.serviceId?.description &&
              parse(service?.serviceId?.description)}
          </p>
        </div>
      </div>
      <Button
        onClick={() =>
          navigate(`/client/my-services/${service?._id}`, { state: service })
        }
        className="bg-[#0595EB] hover:bg-[#0595EB]/90 px-6 rounded-lg shadow-lg"
      >
        View Details
      </Button>
    </div>
    // <div className="py-1 grid grid-cols-2 gap-5 max-[560px]:gap-2">
    //     <div className="">
    //         <img src={`${import.meta.env.VITE_IMG_URL}/${service?.serviceId?.icon}`} />
    //         <span className="mt-1 text-gray-500 text-sm">
    //             {format(new Date(service?.createdAt),"dd MMM yyyy")}
    //         </span>
    //     </div>
    //     <div className="">
    //         <h2 className="text-2xl max-[560px]:text-base font-medium text-gray-900 title-font mb-2">
    //             {service?.serviceId?.name}
    //         </h2>

    //         <button onClick={() => navigate(`/client/my-services/${service?._id}`, { state: service })} className="text-indigo-500 inline-flex max-[560px]:text-sm items-center mt-4">
    //             Learn More
    //             <svg
    //                 className="w-4 h-4 ml-2"
    //                 viewBox="0 0 24 24"
    //                 stroke="currentColor"
    //                 strokeWidth="2"
    //                 fill="none"
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //             >
    //                 <path d="M5 12h14"></path>
    //                 <path d="M12 5l7 7-7 7"></path>
    //             </svg>
    //         </button>
    //     </div>
    // </div>
  );
};

export default MyService;
